export default __webpack_public_path__ + "static/media/ic-btt-bep20.fd8134e4.svg";